import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { PlatformEnum, PlatformService, Tracking } from '@panamax/app-state';
import { ProductDetailViewModel } from '@product-detail/models/product-detail-view-model';
import { QuantityUpdate } from '@shared/models/quantity-update';
import { OrderItemService } from '@shared/services/order-item.service';
import { PdpLnkSrc } from 'src/app/shared/constants/pdp-lnksrc.enum';
import { SearchLoadingState } from '@usf/ngrx-product/lib/models/search-response-state-v2.model';
import { searchLoadingState } from '@usf/ngrx-product';
import { ListFacetSharedObject } from '@app/new-search/models/new-search-facets.model';

@Component({
  selector: 'app-search-result-not-found',
  templateUrl: './search-result-not-found.component.html',
  styleUrls: ['./search-result-not-found.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultNotFoundComponent {
  @Input() coveoTopSellers: ProductDetailViewModel[];
  @Input() search: string;
  @Input() searchLoadingState: SearchLoadingState;
  @Input() isGuestUser = false;
  @Input() listFacet: ListFacetSharedObject;
  @Input() isTopSellersLoading: boolean;

  @Output() productCardClickEvent = new EventEmitter<string>();
  @Output() coveoProductCardClickEvent =
    new EventEmitter<ProductDetailViewModel>();
  @Output() initializedProductCardEvent = new EventEmitter<ElementRef>();
  @Input() isNewSearch = false;
  @Input() hasFacetsSelected = false;

  @Output() clearAllFacets = new EventEmitter<any>();
  @Output() handleReloadResults = new EventEmitter();
  @Output() facetListSelected = new EventEmitter<void>();

  TOP_SELLER_FEATURE_NAME = 'top sellers';
  lnkSrc = PdpLnkSrc.topSellersNullSearchResults;
  isPageEventLoaded = false;
  readonly platformEnum = PlatformEnum;
  constructor(
    private orderItemService: OrderItemService,
    readonly platformService: PlatformService,
  ) {}

  emitProductCardClick(recToken: string) {
    this.productCardClickEvent.emit(recToken);
  }

  emitCoveoProductCardClick(product: ProductDetailViewModel) {
    this.coveoProductCardClickEvent.emit(product);
  }

  emitProductCardInitialization(productCardRef: ElementRef) {
    this.initializedProductCardEvent.emit(productCardRef);
  }

  onQuantityUpdate(data: { quantityUpdate: QuantityUpdate; index: number }) {
    const trackingData: Tracking = {
      analytics: {
        data: {
          products: [
            {
              addMethod: this.TOP_SELLER_FEATURE_NAME,
              merchFeatureName: this.TOP_SELLER_FEATURE_NAME,
            },
          ],
          results: {
            resultRank: data.index + 1,
          },
        },
      },
    };

    this.orderItemService.changeQuantity(
      data.quantityUpdate.productNumber,
      data.quantityUpdate.quantity,
      data.quantityUpdate.isEaches,
      trackingData,
    );
  }

  get SearchLoadingState(): typeof searchLoadingState {
    return searchLoadingState;
  }

  refresh() {
    this.handleReloadResults.emit();
  }

  clearFacets() {
    this.clearAllListFacet();
    this.facetListSelected.emit();
    this.clearAllFacets.emit();
  }

  clearAllListFacet() {
    this.listFacet.values.forEach((value, key) => {
      value.isSelected = false;
    });
    this.listFacet.isValuesSelected = false;
  }
}
